export enum StepView {
    information = 1,
    ticketsSelect
}

const objectFields = <const>["company"];
export type ObjectFields = typeof objectFields[number];

const userFields = <const>["secretary"];
export type UserFields = typeof userFields[number];